
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Trophy } from "lucide-react";

interface GameCountSelectorProps {
  selectedCount: number;
  onCountChange: (count: number) => void;
  isFederalLottery: boolean;
  disabled?: boolean;
}

const GameCountSelector: React.FC<GameCountSelectorProps> = ({ 
  selectedCount, 
  onCountChange, 
  isFederalLottery,
  disabled = false
}) => {
  const options = [4, 5, 6, 7, 8, 9, 10];

  return (
    <div className="flex flex-col items-center gap-2">
      <label className={`text-sm font-medium flex items-center gap-1 ${
        isFederalLottery 
          ? 'text-gold-200' 
          : 'text-gray-700 dark:text-gray-300'
      }`}>
        <Trophy className="w-4 h-4" />
        Quantidade de Jogos
      </label>
      <Select 
        value={selectedCount.toString()} 
        onValueChange={(value) => onCountChange(parseInt(value))}
        disabled={disabled}
      >
        <SelectTrigger className={`w-[140px] ${
          isFederalLottery 
            ? 'bg-gray-800/80 border-gold-400/50 text-gold-100 hover:bg-gray-700/80' 
            : 'bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600'
        } ${disabled ? 'opacity-50' : ''}`}>
          <SelectValue placeholder="Selecione" />
        </SelectTrigger>
        <SelectContent className={isFederalLottery ? 'bg-background border-gold-400/50 z-50' : 'bg-background border-border z-50'}>
          {options.map(count => (
            <SelectItem 
              key={count} 
              value={count.toString()}
              className={`text-foreground hover:bg-muted focus:bg-muted ${isFederalLottery ? 'hover:bg-gold-700/20' : ''}`}
            >
              {count} jogos
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default GameCountSelector;
